import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Box, Typography, styled } from "@mui/material";
import React, { useRef, useState } from "react";
// import { IoMdDocument } from "react-icons/io";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import { useStepperData } from "../../Helpers/Contexts/stepperContext";

// Styled components
const UploadBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "200px",
  border: "2px dashed #444649",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor: "#121212",
  transition: "all 0.3s ease",
  "&:hover": {
    borderColor: "#444649",
    backgroundColor: "#1a1a1a",
  },
}));

const HiddenInput = styled("input")({
  display: "none",
});

const InstructionText = styled(Typography)({
  color: "#aaa",
  marginTop: "8px",
});

const PreviewImage = styled("img")({
  maxWidth: "90%",
  maxHeight: "70%",
  objectFit: "contain",
  borderRadius: "4px",
});

interface FileUploadProps {
  onImageSelect?: any;
  acceptedFileTypes?: string;
  maxFileSizeMB?: number;
  uploadedImage?: any;
  documentName?: string;
  fileInputRef: any;
}

const FileUpload: React.FC<FileUploadProps> = ({
  onImageSelect,
  acceptedFileTypes = "image/*",
  maxFileSizeMB = 5,
  uploadedImage,
  documentName,
  fileInputRef,
}) => {
  const [error, setError] = useState<string | null>(null);

  const { formData, updateFormData } = useStepperData();

  console.log(formData.Highest_Qualification_Certification_URL__c, "formadata");

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#161616",
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <UploadBox
            onClick={handleUploadClick}
            onDragOver={handleDragOver}
            // onChange={handleDrop}
          >
            <HiddenInput
              ref={fileInputRef}
              type="file"
              accept={acceptedFileTypes}
              onChange={onImageSelect}
            />

            {uploadedImage ? (
              <PreviewImage src={uploadedImage} alt="Preview" />
            ) : (
              <>
                {/* <FileUploadIcon /> */}
                <InsertDriveFileIcon
                  style={{ fontSize: 40, color: "#666", marginBottom: 1 }}
                />

                <Typography variant="subtitle1" className="label required">
                  Upload Certificate
                </Typography>
              </>
            )}
          </UploadBox>
        </Box>
        <ul
          style={{
            color: "#A3A3A3",
            fontSize: "14",
            fontWeight: 400,
            paddingLeft: "16px",
          }}
        >
          <li>Supported documents: JPEG/JPG, PNG, and PDF</li>
          <li>Max file size: Up to 5mb</li>
          <li>
            Ensure the document is clearly visible and captured in good
            lighting, with no harsh shadows.
          </li>
        </ul>
      </Box>
    </>
  );
};

export default FileUpload;
